import { AuthorizationViewModel } from "../shared-authz-models";

export type actionToggleEvent = 'user-enabled' | 'auto-enabled' | 'not-enabled';

export class ActionToggleEvent {
  public static readonly userEnabled: actionToggleEvent = 'user-enabled';
  public static readonly autoEnabled: actionToggleEvent = 'auto-enabled';
  public static readonly notEnabled: actionToggleEvent = 'not-enabled';
}

export class ActionToggleMap extends Map<string, actionToggleEvent> {
  public getMapKey(item: AuthorizationViewModel, action: string) {
    return `${item.id}_${action}`;
  }

  public fromItems(items: AuthorizationViewModel[], actions: string[]) {
    for (const item of items) {
      for (const action of actions) {
        this.setValueOnUserEvent(item, action);
      }
    }
  }

  public getItemValue(item: AuthorizationViewModel, action: string) {
    const key = this.getMapKey(item, action);
    return this.get(key);
  }

  public setItemValue(item: AuthorizationViewModel, action: string, value: actionToggleEvent) {
    const key = this.getMapKey(item, action);
    const valueToSet = item.hasAction(action) ? value : ActionToggleEvent.notEnabled;
    this.set(key, valueToSet);
  }

  public setValueOnUserEvent(item: AuthorizationViewModel, action: string) {
    this.setItemValue(item, action, ActionToggleEvent.userEnabled);
  }

  public setValueOnAutoEvent(item: AuthorizationViewModel, action: string) {
    const lastActionWasUser = this.lastActionWasUserEvent(item, action);
    if(!lastActionWasUser) {
      this.setItemValue(item, action, ActionToggleEvent.autoEnabled);
    }
  }
  
  public lastActionWasUserEvent(item: AuthorizationViewModel, action: string) {
    return this.getItemValue(item, action) === ActionToggleEvent.userEnabled;
  }
}